import React, { FC, ReactElement } from 'react';

import Link from '@buyside/components/presentation/Link/link';

import { whitePaperSearchUrl } from '@buyside/util/urlHelper';

import { Maybe } from '@interfaces/graphql-typings';

import styles from './styles.scss';

const Details: FC<{
  elevatorPitch: string;
  hashTags: string[];
  submittedAt: Maybe<string>;
  title: string;
  updatedAt: string;
}> = ({ elevatorPitch, hashTags, submittedAt, title, updatedAt }): ReactElement => {
  return (
    <section className={styles.detailsContainer}>
      <h1 className={styles.title}>{title}</h1>

      <ul className={styles.attributes}>
        <li>
          <span>Updated:</span> <span className={styles.value}>{updatedAt}</span>
        </li>
        <li>
          <span>Submitted:</span> <span className={styles.value}>{submittedAt}</span>
        </li>
      </ul>

      <p className={styles.elevatorPitch}>{elevatorPitch}</p>

      {hashTags.length > 0 && (
        <ul className={styles.hashTags}>
          {hashTags.map(
            (hashTag): ReactElement => (
              <Link key={hashTag} to={whitePaperSearchUrl(`tag=${hashTag}`)}>
                #{hashTag}
              </Link>
            )
          )}
        </ul>
      )}
    </section>
  );
};

export default Details;
